import React, { useRef } from 'react';
import axiosInstance from '../utils/axiosSetup.js';
import Swal from 'sweetalert2';

const SendMail = ({ url }) => {
    const lazyLoadingRef = useRef(null);

    const send_mail = async () => {
        const isConfirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to send mail!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '&nbsp;&nbsp;&nbsp; Yes &nbsp;&nbsp;&nbsp;'
        }).then((result) => result.isConfirmed);

        if (!isConfirm) {
            if (lazyLoadingRef.current) {
                lazyLoadingRef.current.style.display = "none";
            }
            return;
        }

        if (lazyLoadingRef.current) {
            lazyLoadingRef.current.style.display = "inline-block";
        }

        axiosInstance.get(`${process.env.REACT_APP_API_URL}/${url}`)
            .then(({ data }) => {
                if (lazyLoadingRef.current) {
                    lazyLoadingRef.current.style.display = "none";
                }
                Swal.fire({ icon: "success", text: data.message });
            })
            .catch(({ response: { data } }) => {
                if (lazyLoadingRef.current) {
                    lazyLoadingRef.current.style.display = "none";
                }
                Swal.fire({ icon: "error", text: data.message });
            });
    };

    return (
        <button className="btn btn-danger" onClick={send_mail}>
            <i className="fa-regular fa-envelope m-r-5"></i> Send Mail 
            <span ref={lazyLoadingRef} className="ms-2 spinner-border text-light spinner-border-sm" style={{ display: "none" }}></span>    
        </button>
    );
};

export default SendMail;
